/* bloom-cart-summary.js — delivery reassurance above the checkout button.
 *
 * READS THE CANONICAL PROPERTIES, NOT THE VISIBLE ONES
 * The previous version matched properties by their localised key names
 * ("Data livrării", "Destinatar"). That coupled this file to the exact wording
 * in two other files: rewording a label anywhere would make the panel silently
 * find nothing and hide itself. It now reads the hidden machine keys instead —
 * _delivery_iso, _delivery_slot, _bloom_details — which carry no language at
 * all. The date is formatted here with Intl in the storefront locale, and the
 * window label is resolved from the same shop metafield the picker uses.
 *
 * Shown: when it arrives, who receives it. Nothing else. Access details,
 * options and the card message stay on the order and reappear at checkout;
 * asking the customer to re-read their own input at the payment step is
 * friction, and re-showing the card message invites second-guessing.
 */
(function () {
  var host = document.getElementById('bloom-cart-summary');
  if (!host) return;

  var cfgEl = document.querySelector('[data-bl-cart-config]');
  var C = { t: {} };
  if (cfgEl) { try { C = JSON.parse(cfgEl.textContent); } catch (e) {} }
  var T = C.t || {}, SLOTS = C.slots || [], LOCALE = C.locale || 'en';

  function routeRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function slotLabel(id) {
    for (var i = 0; i < SLOTS.length; i++) {
      if (SLOTS[i].id === id) return SLOTS[i].from + '\u2013' + SLOTS[i].to;
    }
    return '';
  }

  function dateLabel(iso) {
    var d = new Date(iso + 'T12:00:00Z');
    var opts = { weekday: 'long', day: 'numeric', month: 'long' };
    try { return new Intl.DateTimeFormat(LOCALE, opts).format(d); }
    catch (e) { return new Intl.DateTimeFormat('en', opts).format(d); }
  }

  function when(item) {
    var p = item.properties || {};
    if (!p._delivery_iso) return '';
    var s = slotLabel(p._delivery_slot);
    return s ? dateLabel(p._delivery_iso) + ' \u00b7 ' + s : dateLabel(p._delivery_iso);
  }

  function recipient(item) {
    var p = item.properties || {};
    if (!p._bloom_details) return '';
    try { return (JSON.parse(p._bloom_details).recipient || '').trim(); }
    catch (e) { return ''; }
  }

  function signature(item) {
    var p = item.properties || {};
    return (p._delivery_iso || '') + '|' + (p._delivery_slot || '');
  }

  function paint(cart) {
    host.textContent = '';
    if (!cart || !cart.items || !cart.items.length) { host.hidden = true; return; }

    var dated = cart.items.filter(function (i) { return when(i); });

    if (!dated.length) {
      host.hidden = false;
      var warn = el('div', 'bl-csum bl-csum--empty');
      warn.appendChild(el('p', 'bl-csum__missing', T.missing || ''));
      host.appendChild(warn);
      return;
    }

    host.hidden = false;
    var panel = el('div', 'bl-csum');

    var lead = el('p', 'bl-csum__lead');
    lead.innerHTML = C.icon || '';
    lead.appendChild(el('span', null, T.heading || ''));
    panel.appendChild(lead);

    var sigs = {};
    dated.forEach(function (i) { sigs[signature(i)] = true; });

    if (Object.keys(sigs).length === 1) {
      panel.appendChild(el('p', 'bl-csum__when', when(dated[0])));
      var who = recipient(dated[0]);
      if (who) {
        panel.appendChild(el('p', 'bl-csum__who',
          T.forWord ? T.forWord + ' ' + who : who));
      }
    } else {
      // Genuinely different delivery days in one cart is rare, but showing only
      // the first one silently would be worse than a little extra text.
      var list = el('ul', 'bl-csum__multi');
      dated.forEach(function (i) {
        var li = el('li');
        li.appendChild(el('span', 'bl-csum__mtitle', i.product_title));
        li.appendChild(el('span', 'bl-csum__mwhen', when(i)));
        list.appendChild(li);
      });
      panel.appendChild(list);
    }

    host.appendChild(panel);
  }

  var inflight = false;
  function refresh() {
    if (inflight) return;
    inflight = true;
    fetch(routeRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(paint)
      .catch(function () {})
      .then(function () { inflight = false; });
  }

  /* The theme repaints .js-mini-cart-content on every cart mutation. Watching
   * that single node for childList changes is the cheapest reliable signal;
   * the timeout debounces bursts so this never fires per inserted node. */
  var target = document.querySelector('.js-mini-cart-content');
  if (target) {
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(refresh, 180);
    }).observe(target, { childList: true });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.js-toggle-cart')) setTimeout(refresh, 220);
  });

  refresh();
})();
